import type { IconNode } from '../types';

/**
 * @name playing-cards-fan
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIuNjUgNy42NWEyIDIgMCAwMTIuNjI5LTEuMDQ2bDUuNTEgMi4zNzRhMiAyIDAgMDExLjA0NiAyLjYyOGwtMy45NTcgOS4xODRhMiAyIDAgMDEtMi42MjggMS4wNDZsLTUuNTEtMi4zNzRhMiAyIDAgMDEtMS4wNDYtMi42Mjh6IiAvPgogIDxwYXRoIGQ9Ik0xOCA3Ljc3N1Y0YTIgMiAwIDAwLTItMmgtNmEyIDIgMCAwMC0yIDJ2MTBhMiAyIDAgMDAxLjEzNyAxLjgwNSIgLz4KICA8cGF0aCBkPSJtOCA0LjM4OS00LjM2NC44MDlhMiAyIDAgMDAtMS42MDIgMi4zM2wxLjgyMiA5LjgzM2EyIDIgMCAwMDIuMzMxIDEuNjAybDIuNTQyLS40NyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/playing-cards-fan
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const PlayingCardsFan: IconNode = [
  [
    'path',
    {
      d: 'M12.65 7.65a2 2 0 012.629-1.046l5.51 2.374a2 2 0 011.046 2.628l-3.957 9.184a2 2 0 01-2.628 1.046l-5.51-2.374a2 2 0 01-1.046-2.628z',
    },
  ],
  ['path', { d: 'M18 7.777V4a2 2 0 00-2-2h-6a2 2 0 00-2 2v10a2 2 0 001.137 1.805' }],
  [
    'path',
    { d: 'm8 4.389-4.364.809a2 2 0 00-1.602 2.33l1.822 9.833a2 2 0 002.331 1.602l2.542-.47' },
  ],
];

export default PlayingCardsFan;
